import { Unknown } from '../../constants/currency-codes';

export const calculateCustoms = (customs, needsCustoms, shouldCheckNeedsCustoms, latestNeedsCustomsCheck) => {
  const shouldNullifyCustoms = (shouldCheckNeedsCustoms && !latestNeedsCustomsCheck) || !needsCustoms;
  if (shouldNullifyCustoms) {
    return null;
  }
  return customs;
};

export const getCustomsItemsCurrencyCode = (customs, defaultCurrencyCode, isStoreCurrencyEnabled) => {
  if (!isStoreCurrencyEnabled) {
    return defaultCurrencyCode;
  }

  const dutiesPaidCode = customs?.dutiesPaid?.code;
  if (dutiesPaidCode && dutiesPaidCode === customs?.postagePaid?.code && dutiesPaidCode !== Unknown) {
    return dutiesPaidCode;
  }
  const firstItemCurrency = customs?.customsItems?.[0]?.unitPrice?.code;
  if (firstItemCurrency) {
    return firstItemCurrency;
  }

  return defaultCurrencyCode;
};
